import { gql } from "lib/apolloClient";
import { attachmentFragment, unitPlanFragment } from "modules/CommonFragments";
import { unitPlanFragment as unitPlanIBFragment } from "IBPlanner/modules/IBFragments";
import { plannerFieldFragment } from "Assessments/modules/AssessmentFragments";
import { assessmentEvaluationFragment } from "modules/AssessmentTool/AssessmentToolFragment";
import { aiFragment } from "./LessonPlanningFragments";

export const getAIConversationsQuery = gql`
  query getAiConverstion($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        entityType
        metadata
        messages {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...aiMessageItem
            }
          }
        }
        attachments {
          ...attachmentItem
          modalityAttachment {
            id
            ... on ToddleDoc {
              id
              content: value
            }
            ... on ModalityFile {
              id
              content
              metadata
            }
          }
        }
      }
    }
  }
  ${aiFragment.aiMessage}
  ${attachmentFragment.attachment}
`;

export const getAIPromptsQuery = gql`
  query getAIPrompts($filters: PromptFilters!) {
    ai {
      prompts(filters: $filters) {
        id
        displayText
        displayTextLocale
        entityType
        promptType
        action
        fieldType
        displaySequence
        groupType
        isTimeDependent
        startDate
        endDate
        promptFields {
          field
          type
          config
          isRequired
        }
        children
        metadata
        templateAssessmentIds
      }
    }
  }
`;

export const getUnitPlanBasicDetailsQuery = gql`
  query getUnitPlanBasicDetails($id: ID!) {
    node(id: $id, type: UNIT_PLAN) {
      ... on UnitPlan {
        ...unitPlanBasicDetailsItem
      }
    }
  }
  ${unitPlanFragment.unitPlanBasicDetails}
`;

export const getUnitPlanCollaboratorsQuery = gql`
  query getUnitPlanCollaborators(
    $id: ID!
    $collaboratorsFilter: CollaboratorFilters
  ) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        ...unitPlanItem
      }
    }
  }
  ${unitPlanIBFragment.unitPlanCollaborator}
`;

export const getAssessmentBasicFieldsQuery = gql`
  query getAssessmentBasicFields($id: ID!, $uids: [String!]) {
    node(id: $id, type: ASSESSMENT) {
      id
      ... on Assessment {
        id
        fields(uids: $uids) {
          ...resourceLibraryFieldItem
        }
        assessmentTools {
          edges {
            node {
              id
              assessmentToolItem {
                ...assessmentEvaluationItem
              }
              assessmentToolType
              isTeacherEvaluationEnable
              isStudentEvaluationEnable
            }
          }
        }
        aiConversation {
          edges {
            node {
              id
              entityType
              entitySubType
              metadata
            }
          }
        }
      }
    }
  }

  ${assessmentEvaluationFragment.assessmentEvaluation}
  ${plannerFieldFragment.resourceLibraryField}
`;

export const getAttachmentGroupAttachmentsQuery = gql`
  query getAttachmentGroupAttachments($id: ID!) {
    node(id: $id, type: ATTACHMENT_GROUP) {
      id
      ... on AttachmentGroup {
        id
        attachments {
          id
          url
          name
          type
          title
          mimeType
          thumbUrl
          metadata
          toddleDoc {
            value
          }
          modalityFile: modalityAttachment {
            ... on ModalityFile {
              content
              metadata
              modalityType
            }
          }
        }
      }
    }
  }
`;
